import { helpers, maxLength, minLength } from '@vuelidate/validators';

// Создание правила проверки максимального значения
export const createMaxValueRule = (
  maxValue: number,
  value?: string,
  unit?: string
) => {
  const text = `Не более ${maxValue} ${unit}!`;
  if (value) {
    if (Number(value) > maxValue) {
      value = value.slice(0, String(maxValue).length);
      return { text: text, v: value };
    }
    return;
  }
};

// Создание правила проверки максимальной длины значения
export const createMaxLengthRule = (maxLengthValue: number, value?: string) => {
  const text = `Не более ${maxLengthValue} символов!`;
  if (value) {
    if (value.length > maxLengthValue) {
      value = value.slice(0, maxLengthValue);
      return { text: text, v: value };
    }
    return;
  }
  return helpers.withMessage(
    `Не более ${maxLengthValue} символов!`,
    maxLength(maxLengthValue)
  );
};

// Создание правила проверки минимального значения
export const createMinValueRule = (
  minValue: number,
  value?: string,
  unit = ''
) => {
  const text = `Не менее ${minValue} ${unit}!`;
  if (value) {
    const numericValue = Number(value);
    const stringValue = String(value);

    if (
      !Object.is(numericValue, -0) &&
      numericValue >= 0 &&
      numericValue < minValue
    ) {
      value = stringValue.slice(0, String(minValue).length);
      value = replaceSymbols(value, '^0{2,}', '0');
      return { text: text, v: value };
    }
    return;
  }
};

// Создание правила проверки минимальной длины значения
export const createMinLengthRule = (minLengthValue: number, value?: string) => {
  const text = `Не менее ${minLengthValue} символа!`;
  if (value) {
    if (value.length < minLengthValue) {
      return { text: text, v: value };
    }
    return null;
  }
  return helpers.withMessage(
    `Не менее ${minLengthValue} символов!`,
    minLength(minLengthValue)
  );
};

// Создание правила валидации с сообщением об ошибке
export const createValidationRule = (params: object, regex: string) => {
  return helpers.withParams(params, helpers.regex(new RegExp(regex)));
};

// Создание правила проверки строки на соответствие регулярному выражению
export const createRegexMark = (
  message = 'Только русские и латинские буквы',
  mark = '',
  regex = 'a-zA-Zа-яёА-ЯЁ0-9'
) => {
  // Экранизация специальных символов в регулярных выражениях
  const escapeRegex = (str: string) =>
    str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  regex = escapeRegex(regex);
  mark = escapeRegex(mark);

  const regexPart = `[${regex}`;
  const markPart = `${mark}]`;

  const regexPattern = `^(${regexPart}${markPart})*$`;
  return createValidationRule(
    {
      message,
      regex: `[^${regex}${mark}]`,
    },
    regexPattern
  );
};

// Функция для замены символов в строке по заданному регулярному выражению
export const replaceSymbols = (
  value: string,
  regex: string | RegExp,
  replacement = ''
) => {
  return String(value).replace(new RegExp(regex, 'g'), replacement);
};

// Функция для проверки первого символа
export const checkStartSymbol = (
  value: string,
  symbol: string,
  errorMessage: string
) => {
  if (value.charAt(0) === symbol) {
    return {
      text: errorMessage,
      v: '',
    };
  }
  return null;
};

// Функция для проверки наличия нескольких одинаковых символов в строке
export const checkMultipleOccurrences = (
  value: string,
  symbol: string,
  errorMessage: string
) => {
  const parts = value.split(symbol);
  if (parts.length > 2) {
    value = parts[0] + symbol + parts.slice(1).join('');
    return {
      text: errorMessage,
      v: value,
    };
  }
  return null;
};

export const capitalizeFirstLetter = () => {
  return helpers.withParams(
    {
      regex: '^([а-яёА-ЯЁa-zA-Z])',
      replacement: (match: string) => match.toUpperCase(),
      message: 'Первая буква заглавная',
    },
    helpers.regex(new RegExp('^[А-ЯЁA-Z]'))
  );
};
